import { Pipe, PipeTransform } from '@angular/core';
import { eSaleStatus } from 'src/app/models/eSaleStatus';

@Pipe({
	name: 'purchaseStatus'
})
export class PurchaseStatusPipe implements PipeTransform {

	transform(status:eSaleStatus) : string {
		switch (status) {
			case eSaleStatus.PENDING_PAYMENT : {
				return "Pago pendiente";
			}
			case eSaleStatus.APPROVED_PAYMENT :
			case eSaleStatus.PENDING_SHIPPING : {
				return "Procesando";
			}
			case eSaleStatus.SHIPPING_DATE_SET : {
				return "Procesado";
			}
			case eSaleStatus.IN_PROGRESS_DELIVERY : {
				return "En viaje";
			}
			case eSaleStatus.RECEIVED : {
				return "Entregado";
			}
			case eSaleStatus.FAILED : {
				return "Entrega fallida";
			}
			case eSaleStatus.CANCELED : {
				return "Compra cancelada";
			}
			default : {
				return "Error";
			}
		}
	}


}
